import styled from "styled-components";
import { T } from "../Theme";

export const CircleStyled = styled.div`
  .circle {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: ${T.grayStepBar};
    display: flex;
    justify-content: center;
    align-items: center;

    font-weight: ${T.fontWeights.bold};
    font-size: ${T.fontSizes.small};
    text-align: center;
    color: #FFFFFF;
  }

  .nextCircles {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: ${T.grayStepBar};
    display: flex;
    justify-content: center;
    align-items: center;

    font-weight: ${T.fontWeights.bold};
    font-size: ${T.fontSizes.small};
    text-align: center;
    color: #000000;
  }

  .active {
    background-color: ${T.primary};
  }

  @media (min-width: 480px) {
    .circle {
      width: 40px;
      height: 40px;
  }
`;

export const ProgressStyled = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));
  align-items: center;
  justify-items: center;
  width: 100%;
  max-width: 520px;
  margin: auto;

  .circleContainer {
    display: flex;
    align-items: center;
    z-index: 10000;
  }

  .line {
    position: absolute;
    width: 75%;
    max-width: 520px;
    z-index: 1000;
    height: 5px;
    background-color: ${T.grayStepBar};
  }


  .lineActive {
    position: absolute;
    width: 75%;
    max-width: ${520/4}px;
    z-index: 1000;
    height: 5px;
    align-items: left;
    background-color: ${T.primary};
  }

  @media (min-width: 480px) {
    .line {
      position: absolute;
      width: 75%;
      max-width: 400px;
  }
`;

export const TextStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));
  justify-content: space-between;
  color: #666666;
  max-width: 520px;
  margin: auto;
  text-align: center;

  p {
    font-size: 12px;
    padding: 4px;
  }

  .textActive {
    color: ${T.primary}};
    font-weight: ${T.fontWeights.bold};
  }

  @media (min-width: 480px) {
    p {
      font-size: ${T.fontSizes.medium};
      padding: 12px 5px;
    }
  }
`;
